import React from 'react';
import { NewsletterSubscribeFormView} from '../../components';
import './styles.scss';

class NewsletterPageView extends React.Component {
  render() {
    return (
      <div id="newsletter-page" className="transition-item">
        <div className="container">
          <div className="row">
            <div className="col-10 offset-1">
              <div className="row newsletter-info-block">
                <div className="col-4">
                  <div className="daily-dose-logo">
                    <img className="img-fluid" src="/img/daily-dose-logo-type.png" alt="Daily dose of love logo" />
                  </div>
                </div>
                <div className="col-8">
                  <div className="newsletter-header">
                    SUBSCRIBE TO THE EXPLORE NEWSLETTER
                  </div>
                  <div className="newsletter-body">
                    Subscribe to the Daily Dose of Love and receive a little bit of love from explore's live cams delivered fresh to your inbox each day.
                    <NewsletterSubscribeFormView />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default NewsletterPageView;
